@if (currentUser$ | async; as currentUser) {
  <app-commenting-user-logo
    [userId]="currentUser.user_id"
    [fallbackUserName]="currentUser.name"
  ></app-commenting-user-logo>
}

<div class="flex-1">
  <app-savable-comment-input
    #input
    data-test-id="reply-comment-input"
    class="w-50"
    [usersMap]="usersMap$ | async"
    [formControl]="textControl"
    [placeholder]="'commenting.replyToThreadPlaceholder' | translate"
    [localStorageKey]="localStorageKey"
    [draftMessage]="draftMessage"
    (gotFocus)="inputGotFocus()"
    (lostFocus)="inputLostFocus()"
  ></app-savable-comment-input>

  @if ((isFocused$ | async) || textControl.value) {
    <div class="flex flex-row gap-3 mt-3">
      <app-new-button
        class="w-20"
        [type]="'primary'"
        [verticalSize]="'small'"
        [loading]="creation$ | async"
        [disabled]="textControl.invalid"
        [size]="'responsive'"
        (click)="reply()"
      >
        {{ buildTranslationKey('replyBtn') | translate }}
      </app-new-button>

      <app-new-button class="w-20" [type]="'basic'" [size]="'responsive'" [verticalSize]="'small'" (click)="cancel()">
        {{ buildTranslationKey('cancelBtn') | translate }}
      </app-new-button>
    </div>
  }
</div>
